class TabMenu{
    constructor(opts){
        this.opts = $.extend(true, {
            el:"#tabmenu",
            idx:1,
            tabCallback(currId, prevId){

            }
        }, opts);

        this.$el = $(this.opts.el);
        this.$tabMenu = this.$el.find("[data-tab-menu]");
        this.$tabCon = this.$el.find("[data-tab-con]");

        this.currId = "";
        this.prevId = "";

        this.init();
    };

    init(){
        this.selection(this.opts.idx);
        this.controls();
    };

    controls(){
        this.$el.on("click", "[data-tab-menu]", (evt)=>{
            this.currId = $(evt.currentTarget).data("tab-menu");
            if(this.currId===this.prevId) return;
            this.selection(this.currId);
        });
    }

    selection(name){
        this.$el.find("[data-tab-menu]").removeClass("item-tab__list--on");
        this.$el.find(`[data-tab-menu=${name}]`).addClass("item-tab__list--on");
        this.$el.find("[data-tab-con]").removeClass("item-con--on");
        this.$el.find(`[data-tab-con=${name}]`).addClass("item-con--on");
        this.prevId = name;
    }

    set seletedSet(name){
        this.selection(name);
    }

};

export default TabMenu;


// WEBPACK FOOTER //
// ./src/js/util/tabmenu.js